export default "__VITE_ASSET__BXAwbwUB__"